import type { SxProps, Theme } from "@mui/material";

import { theme } from "@/src/theme/theme";
import { radius, spacing } from "@/src/theme/tokens";

export const getFilterChipRootSx = (
  isChecked: boolean,
  sx?: SxProps<Theme>
): SxProps<Theme> => [
  {
    height: [40, 36],
    minHeight: [40, 36],
    display: "inline-flex",
    alignItems: "center",
    borderRadius: radius.xs,
    cursor: "pointer",
    border: "1px solid",
    borderColor: isChecked
      ? theme.palette.semantic.success.main
      : theme.palette.misc.outlineBorder,
    backgroundColor: isChecked
      ? theme.palette.semantic.success.selected
      : theme.palette.background.paper,
    transition: "all 0.3s ease",
    px: 1.5,
    py: [spacing.xs / 2, 0],
    "&:hover": {
      backgroundColor: isChecked
        ? theme.palette.semantic.success.focus
        : theme.palette.action.hover
    },
    "&:active": {
      transform: "scale(0.98)"
    }
  },
  ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
];

export const getFilterChipIconSx = (
  hideLabelOnMobile: boolean
): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "20px",
  width: "20px",
  height: "20px",
  flexShrink: 0,
  mr: hideLabelOnMobile ? [0, spacing.sm] : spacing.sm,
  color: theme.palette.text.secondary,
  "& > svg": {
    fontSize: "20px",
    width: "20px",
    height: "20px",
    display: "block",
    margin: "auto"
  }
});

export const getFilterChipLabelSx = (
  isChecked: boolean,
  hideLabelOnMobile: boolean
): SxProps<Theme> => ({
  display: hideLabelOnMobile ? ["none", "block"] : "block",
  color: theme.palette.text.primary,
  fontWeight: isChecked
    ? theme.typography.fontWeightBold
    : theme.typography.fontWeightRegular,
  lineHeight: 1.5
});
